<template>
    <div v-if="loading" class="loading">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  export default {
    name: "AppLoading",
    computed: {
      ...mapMutations({
        loading: state => state.loading.loading
      })
    }
  }
</script>

<style scoped>

</style>
